import Button from '@mui/material/Button';
import React from 'react';

interface SubmitButtonProps {
  className?: string;
  label?: string;
}

function SubmitButton({ className, label }: SubmitButtonProps): JSX.Element {
  return (
    <Button variant='contained' color='primary' type='submit' className={className}>
      {label}
    </Button>
  );
}

SubmitButton.defaultProps = {
  className: undefined,
  label: 'Submit',
};

export default SubmitButton;
